<ng-container *transloco="let t">
<div>
  <nz-page-header class="bg-slate-100" [nzGhost]="false">
    <nz-page-header-title class="text-primary flex items-center gap-2">
      {{ t('customers.title') }}
      <nz-icon nz-tooltip
               nzTooltipPlacement="right"
               [nzTooltipArrowPointAtCenter]="true"
               [nzTooltipTitle]="'nav.featureTooltips.customer' | transloco"
               [nzTooltipOverlayStyle]="{
                 'max-width': '400px',
                 'min-width': '300px',
                 'white-space': 'normal',
                 'line-height': '1.5'
               }"
               nzType="info-circle" nzTheme="outline">
      </nz-icon>
    </nz-page-header-title>
    <nz-page-header-extra>
      <nz-space class="flex flex-col-reverse md:flex-row">
        <div class="pe-3 mt-3 md:mt-0">
          <nz-input-group nzSearch [nzAddOnAfter]="suffixButton" [nzSuffix]="inputClearTpl">
            <input
              type="text"
              nz-input
              [placeholder]="t('customers.searchPlaceholder')"
              (keydown.enter)="this.search()"
              [(ngModel)]="customerSearch" />
          </nz-input-group>
          <ng-template #inputClearTpl>
            <span
              *ngIf="customerSearch"
              nz-icon
              class="ant-input-clear-icon"
              nzTheme="fill"
              nzType="close-circle"
              (click)="reset()">
            </span>
          </ng-template>
          <ng-template #suffixButton>
            <button
              nz-button
              nzType="primary"
              nzSearch
              (click)="search()">
              {{ t('customers.searchBtn') }}
            </button>
          </ng-template>
        </div>
        <div>
          <button
            *appHasAnyPrivilege="'CUSTOMER.ADD'"
            nz-button
            nzType="primary"
            routerLink="/admin/customers/add"
            class="flex items-center justify-center gap-2">
            <lucide-icon name="user-plus" class="icon-size"></lucide-icon>
            {{ t('customers.addBtn') }}
          </button>
        </div>
      </nz-space>
    </nz-page-header-extra>
  </nz-page-header>
</div>

<div class="my-4">
  <nz-table
    #basicTable
    [nzData]="allCustomers"
    [nzShowSizeChanger]="pageSize.length > 5"
    [nzPageSizeOptions]="pageSize.pageSizeOptions"
    [nzBordered]="true"
    [nzFrontPagination]="false"
    [nzTotal]="pageSize.length"
    [nzPageSize]="pageSize.pageSize"
    [nzPageIndex]="pageSize.pageIndex"
    (nzQueryParams)="onTableParamsChange($event)"
    [nzScroll]="{ x: '1100px' }">
    <thead>
      <tr>
        <th [nzSortFn]="sortColumn.compareName" nzWidth="200px">{{ t('customers.table.name') }}</th>
        <th nzWidth="200px">{{ t('customers.table.email') }}</th>
        <th nzWidth="150px">{{ t('customers.table.country') }}</th>
        <th nzWidth="150px">{{ t('customers.table.contact') }}</th>
        <th nzWidth="100px">{{ t('customers.table.status') }}</th>
        <th nzWidth="120px">{{ t('customers.table.itineraries') }}</th>
        <th [nzSortFn]="sortColumn.compareDate" nzWidth="120px">{{ t('customers.table.createdDate') }}</th>
        <th
          nzWidth="200px"
          *appHasAnyPrivilege="'CUSTOMER.EDIT,CUSTOMER.DELETE'">
          {{ t('customers.table.action') }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of basicTable.data">
        <td class="capitalize">{{ data.first_name + ' ' + data.last_name }}</td>
        <td>
          <a *ngIf="data?.email !== '' else email" style="color: #09091a" href="mailto:{{ data.email }}">
            {{ data.email }}
          </a>
          <ng-template #email>
            <p class="text-center">-</p>
          </ng-template>
        </td>
        <td>{{ data.country?.emoji + ' ' + data.country?.name }}</td>
        <td>
          <a *ngIf="data?.contact !== '' else contact" style="color: #09091a" href="tel:{{data?.dialCode}}{{ data.contact }}">
            {{ data?.dialCode }} {{ data.contact }}
          </a>
          <ng-template #contact>
            <p class="text-center">-</p>
          </ng-template>
        </td>
        <td>
          <nz-tag *ngIf="data.active" [nzColor]="'green'">{{ t('customers.status.active') }}</nz-tag>
          <nz-tag *ngIf="!data.active" [nzColor]="'red'">{{ t('customers.status.inactive') }}</nz-tag>
        </td>
        <td>{{ data.itinerariesCount }}</td>
        <td>{{ data.createdAt | date }}</td>
        <td *appHasAnyPrivilege="'CUSTOMER.EDIT,CUSTOMER.DELETE'">
          <div class="flex flex-row gap-3">
            <button
              *appHasAnyPrivilege="'CUSTOMER.EDIT'"
              nz-button
              nzType="default"
              nzSize="small"
              [routerLink]="'/admin/customers/edit/' + data._id"
              class="flex items-center justify-center gap-2">
              <lucide-icon name="pencil" class="icon-size"></lucide-icon>
              {{ t('customers.editBtn') }}
            </button>
            <button
              *appHasAnyPrivilege="'CUSTOMER.DELETE'"
              nz-button
              nzType="default"
              nzSize="small"
              nzDanger
              (click)="showDeleteCustomerModal(data._id, data.itinerariesCount, data.first_name + ' ' + data.last_name)"
              class="flex items-center justify-center gap-2">
              <lucide-icon name="trash-2" class="icon-size"></lucide-icon>
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </nz-table>
</div>
</ng-container>
